

<template>
  <div class="page5">
     <div class="h90"></div>
     <div class="bg4" :style="{background: 'url('+url+'/assets/bg4.png) no-repeat'}">
        <div class="main">
          <div class="title1">中国物联网资深服务商</div>
          <div class="title2">江苏野马从不认为自己是最好的</div>
          <div class="title3">但却始终为一流的品牌服务</div>
        </div>
     </div>
     <div class="content">
        <div class="left" :class="{'ani_left': ani_left_5}" v-if="ani_left_5">
          <p class="title">需要专家为您服务吗？</p>
          <p class="title mb35">江苏野马信息专家一对一为您提供服务</p>        
          <p class="input"><input value="" placeholder="联系人"  v-model="contacts"></p>
          <p class="input"><input value="" placeholder="联系电话" v-model="telphone"></p>
          <p class="input"><textarea value="" placeholder="您的需求" v-model="demand"></textarea></p>
          <p class="button" @click="submit">提   交</p>
        </div>
        <div class="right" :class="{'ani_right': ani_right_5}"  v-if="ani_left_5">
          <div class="logo">
              <img :src="url + '/assets/logo.png'">
               江苏野马软件科技有限公司
          </div>              
          <p class="p1">
            <img class="img1 pulse" :src="url + '/assets/icon-phone-2.png'">
            0516-83309697  15380187318（周经理）
          </p>
           <p class="p1">
            <img class="img2" :src="url + '/assets/icon-mail.png'">
            songyf@yemast.com (业务咨询)
          </p>
           <p class="p1">
            <img class="img2" :src="url + '/assets/icon-mail.png'">
            hr@yemast.com (企业招聘)
          </p>
           <p class="p1">
            <img class="img3" :src="url + '/assets/icon-add.png'">
            中国~江苏~徐州市云龙区绿地商务城Office B座24层
          </p>
        </div>
     </div>
     <div class="bottom">
       <p><a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">Copyright@ 2020 江苏野马软件科技有限公司版权所有  |  苏ICP备15023254号-1</a></p>
     </div>
  </div>
</template>
<script>
import defaultSettings from '@/defaultSettings'
export default {
  name: "page5",
  data() {
    return {
      url: defaultSettings.url,
      contacts: '',
      telphone: '',
      demand: ''
    };
  },
  props:{
    ani_left_5: {
        type: [Boolean],
        require: false,
        default: false,
    },
    ani_right_5: {
        type: [Boolean],
        require: false,
        default: false,
    },
  },
  created() {},
  mounted() {},
  methods: {
    submit () {
      const that = this
      const myreg = /^[1][3,4,5,7,8][0-9]{9}$/
      if (!this.contacts) {
        this.$message({
          showClose: true,
          message: '请输入联系人',
          type: 'warning'
        })
      } else if(!this.telphone) {
        this.$message({
          showClose: true,
          message: '请输入联系电话',
          type: 'warning'
        })
      } else if(!myreg.test(this.telphone)){
        this.$message({
          showClose: true,
          message: '请输入正确联系电话',
          type: 'warning'
        })
      } else if (!this.demand) {
        this.$message({
          showClose: true,
          message: '请输入您的需求',
          type: 'warning'
        })
     } else {
        this.$http.post('https://server.yemast.com/api/demand', {source: '',contacts: this.contacts, telphone: this.telphone, demand: this.demand}).then(function(res){
          console.log(res)
          if (res.data.success === true) {
            that.$message({
              message: '提交成功',
              type: 'success'
            });
          }
          if (res.data.success === false) {
             that.$message({
              message: '提交失败',
              type: 'warning'
            });
          }
        }, function(){
          that.$message({
            message: '请求失败',
            type: 'warning'
          });
        })
      }
    }
  }
};
</script>
<style lang="less" scoped>
input::placeholder{
  color:#999!important;
  font-family: Microsoft YaHei;
  font-size:16px;
}
textarea::placeholder{
  color:#999!important;
  font-size:16px;
  font-family: Microsoft YaHei;
}
.page5 {
    margin:0 auto;
    text-align: center;
    .h90{
      height:90px;
    }
    .bg4{
      background-size: 100% 100%!important;
      height:50vh;
      margin-top:-90px;
    }
    .main{
      width:1200px;
      margin:0 auto;
      .title1{
            height:100px;
            padding-top:19vh;
            font-size: 60px;
            font-weight: bold;
            color: #fff;
        }
        .title2{       
            font-size: 28px;
            color: #ffffffe6;
            margin-top:40px;
        }
        .title3{
          font-size: 22px;
          color: #ffffffe6;
          margin-top:10px;
        }
    }
    .content{
      width:1200px;
      margin:5vh auto 0;
      display: flex;
      .left{
        width:50%;
        text-align: left;
        .title{
          font-size: 20px;
          color: #333;
        }
        .mb35{
          margin-bottom:20px;
        }
        .input{
          input{
            width:454px;
            height:40px;
            font-size: 16px;
            padding-left:20px;
            line-height: 40px;
            color:#333;
            border-radius: 3px;
            border:1px solid #E6E6E6;
            margin-bottom:8px;
          }
          textarea{
            font-size: 16px;
            width:454px;
            height:90px;
            padding-left:20px;
            padding-top:10px;
            color:#333;
            border-radius: 3px;
            border:1px solid #E6E6E6;
            margin-bottom:8px;
          }
        }
        .button{
          width:476px;
          height:45px;
          line-height:50px;
          text-align: center;
          color:#fff;
          font-size: 18px;
          background: #67B8EA;
        }
      }
      .right{
        width:50%;
        margin-top:50px;
        margin-left:100px;
        text-align: left;
        .logo{
          font-size: 22px;
          color:#333;
          margin-bottom:40px;
          img{
            width:218px;
            height:60px;
            vertical-align: middle;
          }
        }
        .p1{
          font-size: 18px;
          color:#333;
           margin-bottom:25px;
          .img1{
            width:20px;
            height:20px;
            vertical-align: middle;
            margin-right:20px;
          }
          .img2{
            width:18px;
            height:14px;
            vertical-align: middle;
            margin-right:20px;
          }
          .img3{
            width:18px;
            height:22px;
            vertical-align: middle;
            margin-right:20px;
          }
        }
      }
    }
    .bottom{
      position: absolute;
      width:100%;
      bottom:20px;
      p{
         color:#999;
        font-size: 14px;
         text-align: center;
         width:1600px;
         margin:0 auto;
         a{
            color:#999;
            text-decoration: none;
         }
      }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/page5.vue